<template>
  <div class="app-container">
    <el-row type="flex" class="row-bg" justify="center">
      <el-form :model="userData" label-position="right" size="mini" style="width:30%">
        <el-form-item label="角色类型" v-if="isEdit">
          <span>{{userData.role ? '超级管理员' : '普通管理员'}}</span>
          <!-- <el-select v-model="userData.role" placeholder="请选择">
            <el-option
              v-for="item in roleTreeData"
              :key="item.id"
              :label="item.roleName"
              :value="item.id">
            </el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item label="用户名" v-if="isEdit">
          <span>{{userData.username}}</span>
        </el-form-item>
        <el-form-item label="姓名" v-if="isEdit">
          <span v-if="$route.query.check">{{userData.fullname}}</span>
          <el-input v-else v-model="userData.fullname" style="width:30%"></el-input>
        </el-form-item>
        <el-form-item label="手机号" v-if="isEdit">
          <span v-if="$route.query.check">{{userData.phone}}</span>
          <el-input v-else v-model="userData.phone" style="width:60%"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" v-if="isEdit">
          <span v-if="$route.query.check">{{userData.email}}</span>
          <el-input v-else v-model="userData.email" style="width:60%"></el-input>
        </el-form-item>
        <el-form-item label="角色权限" v-if="isEdit">
          <el-select v-model="userData.roleIds" :multiple="roleTreeMultiple" placeholder="请选择">
            <el-option
              v-for="item in roleTreeData"
              :key="item.id"
              :label="item.roleName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户编号：" v-if="!isEdit">
          <span>{{userData.createdBy}}</span>
        </el-form-item>
        <el-form-item v-if="!isEdit" label="账号：">
          {{userData.userNum}}
        </el-form-item>
        <el-form-item v-if="!isEdit" label="用户类型：">
          {{userData.userType | userType}}
        </el-form-item>
        <el-form-item v-if="!isEdit" label="账户状态：">
          <el-select v-model="userData.userState" placeholder="请选择" clearable>
            <el-option v-for="item in userStateList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="!isEdit" label="注册时间：">
          {{userData.createdDate | formatDateTimeDefault}}
        </el-form-item>
        <el-form-item>
          <span v-if="!isEdit">
            <a style="color:rgba(0, 184, 130, 1)" @click="resetPwd()">忘记密码?</a>点击重置密码为123456
          </span>
          <span v-if="isEdit">
            <a style="color:rgba(0, 184, 130, 1)">忘记密码?</a>点击重置密码为gree8888
          </span>
          <el-form-item style="margin:10px 0">
            <el-button type="primary" @click="resetPwd()">重置密码</el-button>
          </el-form-item>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="confirm">确认</el-button>
          <el-button type="primary" @click="$router.back(-1)">返回</el-button>
        </el-form-item>
      </el-form>
    </el-row>

  </div>
</template>
<script>
export default {
  data() {
    return {
      userData: {
        roleIds: undefined
      },
      userStateList: [
        {
          label: "冻结",
          value: 0,
        },
        {
          label: "可用",
          value: 1,
        },
      ],
      isEdit: true,
      roleTreeData: [],
      roleTreeMultiple: false
    }
  },
  filters: {
    userType(value) {
      if (value === 1) {
        return '用户'
      } else if (value === 2) {
        return '回收员'
      } else {
        return '网点'
      }
    },
    userStateType(value) {
      if (value) {
        return '可用'
      } else {
        return '冻结'
      }
    },
  },
  created() {
    this.getList();
    this.getRoleList();
    console.log(this.$route.query, "route")
    if (this.$route.query.type === 'system') {
      this.isEdit = true
    } else {
      this.isEdit = false
    }
  },
  methods: {
    getList() {
      let params = {
        userId: this.$route.query.id
      }
      if (this.$route.query.type === 'system') {
        if (this.$route.query.key) {
          this.HttpService.get(`/autoapp-recovery-server-auth/api/recoveryManage/getManageImportById?id=${this.$route.query.id}&key=${this.$route.query.key}`, params).then(res => {
            if (res.statusCode === 200) {
              const resData = res.data || []
              const tblRoleList = resData.tblRoleList || []
              const onlyOneRoleId = tblRoleList[0].id || ''
              resData.roleIds = this.roleTreeMultiple ? tblRoleList.map(item => item.id) : onlyOneRoleId
              this.userData = resData
            }
          })
        } else {
          this.HttpService.get(`/autoapp-recovery-server-auth/api/recoveryManage/getManageInfo?userId=${this.$route.query.id}`, params).then(res => {
            if (res.statusCode === 200) {
              const resData = res.data || []
              const tblRoleList = resData.tblRoleList || []
              const onlyOneRoleId = tblRoleList[0].id || ''
              resData.roleIds = this.roleTreeMultiple ? tblRoleList.map(item => item.id) : onlyOneRoleId
              this.userData = resData
            }
          })
        }

      } else {
        this.HttpService.get(`/autoapp-recovery-server-auth/api/recoveryUser/getUserById/${this.$route.query.id}`, params).then(res => {
          if (res.statusCode === 200) {
            const resData = res.data || []
            const tblRoleList = resData.tblRoleList || []
            const onlyOneRoleId = tblRoleList[0].id || ''
            resData.roleIds = this.roleTreeMultiple ? tblRoleList.map(item => item.id) : onlyOneRoleId
            this.userData = resData
          }
        })
      }
    },

    resetPwd() {
      let params = {
        userId: this.$route.query.id
      }
      if (this.$route.query.type === 'system') {
        this.HttpService.post(`/autoapp-recovery-server-auth/api/recoveryManage/resetPwd/${this.$route.query.id}`, params).then(res => {
          if (res.statusCode === 200) {
            this.$message.success('重置成功')
          }
        })
      } else {
        this.HttpService.post(`/autoapp-recovery-server-auth/api/recoveryUser/resetPwd/${this.$route.query.id}`, params).then(res => {
          if (res.statusCode === 200) {
            this.$message.success('重置成功')
          }
        })
      }

    },
    confirm () {
      const params = {
        ...this.userData,
        roleIds: Array.isArray(this.userData.roleIds) ?this.userData.roleIds : Array.of(this.userData.roleIds)
      }
      if (this.$route.query.type === 'system') {
        this.HttpService.post(`/autoapp-recovery-server-auth/api/recoveryManage/updateManage`, params).then(res => {
          if (res.statusCode === 200) {
            this.$message.success('修改成功')
            this.$router.back(-1)
          }
        })
      } else {
        this.HttpService.post(`/autoapp-recovery-server-auth/api/recoveryUser/updateState`, params).then(res => {
          if (res.statusCode === 200) {
            this.$message.success('修改成功')
            this.$router.back(-1)
          }
        })
      }

    },
    // 将树形转为一维数组
    flattenTree (treeData) {
      const result = []
      const flatten = (node) => {
        result.push(node)
        if (node.children) {
          for (const child of node.children) {
            flatten(child)
          }
        }
      }
      for (const node of treeData) {
        flatten(node)
      }
      return result
    },
    // 获取角色列表
    getRoleList () {
      this.tableDataLoading = true;
      const url = `/autoapp-recovery-server-auth/api/tbl-role/pageRole?pageNum=1&pageSize=999999`
      this.HttpService.get(url).then(res => {
        this.tableDataLoading = false
        if (res.statusCode === 200) {
          // console.log('====res=====', res)
          this.roleTreeData = this.flattenTree(res.data) || []
        } else {
          const tipMsg = res.message || '请求出错'
          this.$message.error(tipMsg)
        }
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/userEdit.vue